import { type Types } from '@fiverr-private/theme';

export const DIALOG_WIDTH: Types.ResponsiveWidthType = {
    sm: 520,
    md: 600,
    lg: 720,
    xl: 900,
};

export const fullWidthProps: Types.FlexLayoutProps = {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    top: 0,
    borderRadius: 'none',
    maxHeight: 'unset',
    maxWidth: '100%',
    width: '100%',
};
